import * as React from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';

import * as selectors from 'chronos-selectors';
import * as actions from 'chronos-actions';
import {
  calculateCalendarSelection,
} from 'chronos-utils';

import {
  Calendar,
} from 'chronos-components';

const mapState = state => ({
  data: selectors.getWorklogsMapGroupedByISODateAndIssue(state),
  date: selectors.getUiState('calendarDate')(state),
  jiraUrl: selectors.getUiState('jiraUrl')(state),
  calendarSelection: selectors.getCalendarSelection(state),
  calendarSelectionArr: selectors.getUiState('calendarSelection')(state),
  status: selectors.getStatus(state, 'issues.requests.loadingFilterOptions.status'),
});

const CalendarContainer = () => {
  const {
    data,
    date,
    jiraUrl,
    calendarSelection,
    calendarSelectionArr,
    status,
  } = useSelector(mapState);
  const dispatch = useDispatch();

  return (
    <Calendar
      date={date}
      data={data}
      jiraUrl={jiraUrl}
      calendarSelection={calendarSelection}
      onSelect={(newDate, event) => dispatch(
        actions.setUiState({
          calendarSelection: (
            calculateCalendarSelection(
              calendarSelectionArr,
              newDate,
              event,
            )
          ),
        }),
      )}
      onAddWorklog={(
        worklogFormDate,
        issueId,
      ) => {
        dispatch(actions.setUiState({
          worklogFormModalIsOpen: true,
          worklogFormDate,
          worklogFormIssueId: issueId || null,
        }));
      }}
      onShowScreenshotsViewer={(worklogIds) => {
        dispatch(actions.setUiState({
          screenshotsViewerModalIsOpen: true,
          screenshotsViewerWorklogIds: worklogIds,
        }));
      }}
      onEditWorklog={(editWorklogId) => {
        dispatch(actions.setUiState({
          editWorklogId,
          worklogFormModalIsOpen: true,
          worklogFormDate: null,
          worklogFormIssueId: null,
        }));
      }}
      onRemoveWorklog={(deleteWorklogId) => {
        dispatch(actions.setUiState({
          deleteWorklogId,
          confirmDeleteWorklogIsOpen: true,
        }));
      }}
      fetching={status.pending}
    />
  );
};


export default CalendarContainer;
